<template>
  <div class="chart">
    <IEcharts :option="line"></IEcharts>
  </div>
</template>
<script>
import IEcharts from 'vue-echarts-v3/src/lite.js'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'

export default {
  name: 'chart-line',
  components: {
    IEcharts
  },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {
            xAxis:[],
            series:[],
        }
      }
    }
  },
  watch: {
    dataSource(newVal, val) {
      this.initView()
    },
  },
  mounted() {
    this.initView()
  },
  data() {
    return {
      line: {

        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          top: '10%',
          containLabel: true
        },
        tooltip: {
          show: "true",
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLabel: {
            color: '#666',
          },
          axisLine: {
            show: false,
            color: '#DEE3E7',
          },
          data: [],
          splitLine: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          show: true,
          axisLabel: {
            color: '#666',
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#DEE3E7',
            },
          },
          axisTick: {
            lineStyle: {
              color: '#DEE3E7',
            },
          },
          splitLine: {
            lineStyle: {
              color: '#DEE3E7',
            },
          },
        },
        color: ['#5482D2', '#D185FF', '#86E687', '#EC7A8A'],
        series: [
        ]
      }
    }
  },
  methods: {
    initView() {
         this.line.xAxis.data = this.dataSource.xAxis
         this.line.series = this.dataSource.series
    }
  }
}
</script>
<style scoped>
.chart {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: 190px;
}
</style>


// WEBPACK FOOTER //
// src/components/performance/components/line.vue